import React from "react";
import Viewer from "viewerjs/dist/viewer.esm";

let viewer = null;

const ImageGallery = (props) => {
    const onLoad = () => {
        if (viewer) {
            viewer.destroy();
        }

        viewer = new Viewer(document.getElementById("image-gallery"), {
            toolbar: {
                zoomIn: 1,
                zoomOut: 1,
                oneToOne: false,
                reset: 1,
                prev: 1,
                play: false,
                next: 1,
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1,
            },
        });
    };

    const thumbs = props.images.map((image, index) => {
        return (
            <li key={`${index}of${props.images.length}`}>
                <img
                    src={`/api/pre-shipment-packages/${props.productId}/images/${image.imageId}`}
                    alt={image.imageView}
                />
                <p className="txt-center">{image.imageView}</p>
            </li>
        );
    });

    return (
        <ul
            id="image-gallery"
            className="image-gallery"
            onLoad={onLoad}
        >
            {thumbs}
        </ul>
    );
};

export default ImageGallery;
